import React, { useEffect } from "react";
import { ConfigProvider } from "antd";
import esES from "antd/locale/es_ES";
import { useDispatch } from "react-redux";
import { fetchUserBytoken } from "./features/authSlice";
import "./App.less";
import "./assets/styles/utility.css";
import AdminRoutes from "./routes/admin";
import { AUTH_TOKEN_KEY, AUTH_USER_ID_KEY } from "./constants";

const App = () => {
  const dispatch = useDispatch();

  useEffect(() => {
    const token = localStorage.getItem(AUTH_TOKEN_KEY);
    const userId = localStorage.getItem(AUTH_USER_ID_KEY);

    const isValid = (v) => Boolean(v && v !== "null" && v !== "undefined");

    if (isValid(token) && isValid(userId)) {
      console.log("🔄 Restaurando sesión desde localStorage...");
      dispatch(fetchUserBytoken({ id: userId, token }));
    } else {
      console.log("⛔ No hay sesión válida almacenada.");
    }
  }, [dispatch]);

  return (
    <ConfigProvider locale={esES}>
      <AdminRoutes />
    </ConfigProvider>
  );
};

export default App;